import React from 'react';
import { Radio } from 'react-bootstrap';
import { getDataFromProps, propagateData, getUId } from '../utils';
import { safeMutate } from '../../../../utils/GeneralUtils';

// props = {
//   data: {
//       name: <string>,
//       value: <string>,
//       label: <string>,
//       checked: <boolean>,
//       disabled: <boolean>,
//       className: <string>
//       helpText: {
//          className: <string>
//          content: <string>
//       }
//   },
//   uId: <uniqueIdentifier>,
//   inline = <boolean>,
//   onChange = <handler>
// }

const ChrRadio = (props) => {
  const formData = getDataFromProps(props);
  const myUId = getUId(props);

  const onChangeHandler = (event) => {
    const newFormData = safeMutate(formData, draftData => { draftData.checked = true });
    propagateData(event, myUId, newFormData, props);
  };

  const radioElement = (
    <Radio
      name={formData.name}
      value={formData.value}
      inline={props.inline || false}
      checked={formData.checked || false}
      disabled={formData.disabled || false}
      className={formData.className}
      onChange={onChangeHandler}
      aria-label={ formData["aria-label"] || formData.label }
    >
      {formData.label}
      {formData.helpText && <div className={formData.helpText.className}> {formData.helpText.content} </div>}
    </Radio>
  );

  if (formData.wrapperClassName) {
    return <div className={formData.wrapperClassName}>{radioElement}</div>;
  }

  return radioElement;
};

export default ChrRadio;